import { Component, Inject, Input, OnChanges, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { Currency } from 'projects/common/model/landingModel';
import { OfferCardData, OfferCardDataPrice } from "../offer-card-data.model";
import { LoyaltyMode } from '@shopping-angular-components/loyalty'
import { EvaSize } from '@shopping-angular-components/loader';
import { MediaPictureService } from "../../../services/media-picture.service";
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { HotelsBoxService } from 'projects/common/services/hotelsBox.service';
import {isPlatformBrowser} from '@angular/common';

declare var window: any;

@Component({
  selector: 'cluster-pricebox',
  template: `
    <div class="cluster-pricebox" *ngIf="price">
      <div class="eva-3-pricebox-cluster -responsive">
        <span class="discount-top-label -benefits eva-3-driver" *ngIf="price.promo?.discount_top_label">
          <span class="driver-text">
            <span class="-eva-3-tc-gray-0">{{price.promo.discount_top_label?.label}} </span>
            {{price.promo.discount_top_label?.discount_text}}
          </span>
        </span>
        <div class="offer-card-pricebox-label eva-3-label -sm -top-left" *ngIf="(price.promo?.ribbon && !price.promotions_list) || price.promo?.discount"
        [ngClass]="price.promo.promo_type === 'CROSS_SELLING' ? '-purple' :
        price.promo.promo_type === 'COUPON' ? '-green' :
        price.promo.promo_type === 'HOTSALE' ? '-hotsale' :
        price.promo.promo_type === 'LOGGED_IN' ? '-secret-deals' : 
        price.promo.promo_type === 'IFOOD' ? '-ifood' : '-green'">

          <span class="label-container">
            <span class="-eva-3-bold label-text">
              <i *ngIf="price.promo.promo_type === 'COUPON'" class="label-icon eva-3-icon-{{isStressContent ? 'pm-pad' : 'ticket'}} -eva-3-mr-xsm"></i>
              <i *ngIf="price.promo.promo_type === 'CROSS_SELLING'" class="label-icon eva-3-icon-pig-offer-filled -eva-3-mr-xsm"></i>
              <i *ngIf="price.promo.promo_type === 'HOTSALE'" class="label-icon eva-3-icon-promotion -eva-3-mr-xsm"></i>
              <i *ngIf="price.promo.promo_type === 'LOGGED_IN'" class="eva-3-icon-gift label-icon -eva-3-tc-red-3"></i>
              {{getRibbon()}}
            </span>
          </span>
        </div>

        <dual-promo *ngIf="price.promotions_list" [promotionsList]="price.promotions_list" position="-top-left"></dual-promo>

        <div class="pricebox-top-container">
          <div class="pricebox-value-container">
            <div class="pricebox-small-text">{{price.message}}</div>
            <div class="pricebox-value">
              <div class="pricebox-strikethrough-text" *ngIf="price.promo">{{currency.symbol}}{{price.promo.real_price}}</div>
<!--                    <span class="pricebox-info-icon"><i class="eva-3-icon-info"></i></span> todo: lo dejo comentado porque es el i de info -->
                <span class="pricebox-currency">{{currency.symbol}}</span>
                <span class="pricebox-big-text">{{price.total_amount}}</span>
            </div>
<!--                  <div class="pricebox-small-text -description"></div> todo: lo dejo comentado porque es el mensaje abajo del precio-->
          </div>

          <div *ngIf="price.tax_message" class="offer-card-pricebox-description 
            {{price.disclaimer ? 'tax-message-with-disclaimer' : 'tax-message'}}">{{price.tax_message}}</div>

           <div *ngIf="price.disclaimer"
            class="offer-card-pricebox-description disclaimer-message">{{price.disclaimer}}</div>
            
          <div class="pricebox-action">
              <eva-button [moduleId]="moduleId"
                          [moduleIndex]="moduleIndex"
                          [uniqueId]="uniqueId"
                          [position]="index"
                          [nofollow]="true"
                          [newTab]="true"
                          [options]="{type: '-primary', size:'-md', link_text: (buttonTextKey) | translate, as_span: true}"
              ></eva-button>
          </div>

          <div *ngIf="data.reference_date" class="pricebox-reference-date">
              <div>{{'offers.smallText.date' | translate}}</div>
              <div class="pricebox-small-text">{{data.reference_date}}</div>
          </div>

        </div>

        <loyalty-offer-info [loyaltyInfo]="data.loyalty_info" [loyaltyMode]="loyaltyMode" [locale]="locale" [flow]="flow" product="nymeria-gui"></loyalty-offer-info>

        <div class="pricebox-bottom-container" *ngIf="data.payments">{{data.payments}}</div>
      </div>
    </div>

    <div class="cluster-pricebox without-price" *ngIf="!price">
      <div class="pricebox-top-container">
          <div class="pricebox-value-container">
              <div class="pricebox-small-text -eva-3-mb-lg">{{"hotelInCity.hotelWithoutPrice" | translate}}</div>
          </div>
        <div class="pricebox-action">
          <eva-button [moduleId]="moduleId"
                      [moduleIndex]="moduleIndex"
                      [uniqueId]="uniqueId"
                      [position]="index"
                      [options]="{type: '-primary', full_width:true, size:'-md', link_text: (buttonTextKey) | translate, as_span: true}"
                      [disableHref]="sboxAutocomplete ?? false"
                      (clickEvent)="sboxAutocomplete && openDatepicker()"
          ></eva-button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./cluster-pricebox.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ClusterPriceboxComponent implements OnInit, OnChanges {

  @Input() data: OfferCardData;
  @Input() index: number;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId?: string;
  @Input() currency: Currency;
  @Input() locale: string;
  @Input() loyaltyMode: LoyaltyMode | null;
  @Input() product;
  @Input() flow;
  @Input() sboxAutocomplete?: boolean;

  evaSizes = EvaSize;

  stars: Array<any>;
  price: OfferCardDataPrice;
  isStressContent: boolean;
  buttonTextKey: string;
  isHotelVrOrPromotion: boolean;

  constructor(
    public mediaPictureService: MediaPictureService, 
    landingModelService: LandingModelService,
    private hotelsBoxService: HotelsBoxService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.isStressContent = landingModelService.getLandingModel().abTests?.ab.includes("S-PIG-RETURNERS|branch_test");
  }

  ngOnInit(): void {
    this.initStars();
    this.initPrice();
    this.isHotelVrOrPromotion = ['hotels', 'vacation_rentals', 'promotions'].includes(this.data.product);
    if (isPlatformBrowser(this.platformId)) {
      this.buttonTextKey = (this.isHotelVrOrPromotion && window.hotelsBox) ? 'offers.buttons.validDates.absolute' : 'offers.buttons.seeDetail';
    }
  }

  ngOnChanges(): void {
    this.initPrice();
  }

  private initStars(): void {
    if (this.data.stars) {
      this.stars = new Array(Number(this.data.stars)).fill({});
    }
  }

  private initPrice(): void {
    if (this.data.offer_alternatives) {
      this.price = this.data.offer_alternatives[0].price[this.currency.code];
    } else if (this.data.price) {
      this.price = this.data.price[this.currency.code];
    }
  }

  getRibbon() : string {
    return this.price.promo.ribbon || `- ${this.price.promo.discount}%`;
  }

  openDatepicker() {
    if (this.flow != 'landing:detail' && this.isHotelVrOrPromotion && window.hotelsBox) {
      this.hotelsBoxService.updateHotelsData(this.data);
    }
  }
}
